/**
 * @file RbtStaffingCharlotteNc.jsx
 * @description Agency market page at /rbt-staffing-charlotte-nc. Expansion page: honest early-market framing, no local counts. Layout lives in
 *   AgencyMarketPage; this file owns the SEO head, breadcrumb JSON-LD and the
 *   page's copy/visual config (agencyMarket.charlotte.* keys).
 * @module components/RbtStaffingCharlotteNc
 */
import { useTranslation } from "react-i18next";
import { ClockIcon } from "./Icons";
import { agencyChips } from "./AgencyVisuals";
import AgencyMarketPage from "./AgencyMarketPage";
import { useBreadcrumbJsonLd, useSiteSchema } from "../lib/seoSchema";
import { usePageSeo } from "../lib/seo";

export default function RbtStaffingCharlotteNc({ onNavigate }) {
  const { t } = useTranslation();
  const k = (key) => t(`agencyMarket.charlotte.${key}`);

  usePageSeo({
    title: "RBT Staffing in Charlotte, NC | Reach ABA Providers with ABAcases",
    description: "RBT staffing in Charlotte, NC? Post your ABA case on ABAcases and reach verified local RBTs, BTs, BCBAs, and BCaBAs by schedule, setting, and credential.",
    canonical: "/rbt-staffing-charlotte-nc",
  });
  useSiteSchema(); // global Organization + WebSite
  useBreadcrumbJsonLd("bc-jsonld-rbt-staffing-charlotte-nc", [
    { name: "Home", url: "/" },
    { name: "For ABA Agencies", url: "/aba-agencies" },
    { name: "RBT Staffing in Charlotte, NC", url: "/rbt-staffing-charlotte-nc" },
  ]);

  return (
    <AgencyMarketPage
      onNavigate={onNavigate}
      source="rbt_staffing_charlotte_nc"
      pagePath="/rbt-staffing-charlotte-nc/"
      market="charlotte"
      crumb={k("title")}
      badge={k("badge")}
      title={k("title")}
      subtitle={k("subtitle")}
      chips={[{ Icon: ClockIcon, label: t("agencyMarket.chipStandOut") }, ...agencyChips(t).slice(1)]}
      coverageTitle={k("coverageTitle")}
      body={k("body")}
      visual={{ type: "rings", center: "Charlotte", towns: [{ name: "Huntersville", angle: -95, outer: true }, { name: "Concord", angle: -35, outer: true }, { name: "Mint Hill", angle: 10 }, { name: "Matthews", angle: 55 }, { name: "Pineville", angle: 105 }, { name: "Gastonia", angle: 180, outer: true }] }}
      area={k("area")}
      links={[
        { to: "rbt-jobs-charlotte-nc", label: t("agencyMarket.linkJobsCharlotte") },
        { to: "rbt-jobs-north-carolina", label: t("agencyMarket.linkNcHub") },
        { to: "aba-provider-waitlist", label: t("agencyMarket.linkWaitlist") },
      ]}
      showOutsideFloridaNote
    />
  );
}
